import { Box } from '@chakra-ui/react';
import { Button } from '@time-line/components/common';
import {
  ApplePodcasts,
  GooglePodcasts,
  Rss,
  Spotify,
  Stitcher,
} from '@time-line/components/icons';
import type { Platform } from 'types/cms/blog/Platform';

const PLATFORMS = {
  spotify: {
    title: 'Spotify',
    id: 'spotify',
    icon: <Spotify width="sm" />,
  },
  applePodcasts: {
    title: 'Apple Podcasts',
    id: 'applePodcasts',
    icon: <ApplePodcasts width="sm" />,
  },
  google: {
    title: 'Google',
    id: 'google',
    icon: <GooglePodcasts width="sm" />,
  },
  stitcher: {
    title: 'Stitcher',
    id: 'stitcher',
    icon: <Stitcher width="sm" />,
  },
  rss: {
    title: 'RSS',
    id: 'rss',
    icon: <Rss width="sm" />,
  },
} as const;

interface PodcastPlayerPlatformsProps {
  platforms: Platform[];
}

export function PodcastPlayerPlatforms({
  platforms,
}: PodcastPlayerPlatformsProps) {
  return (
    <Box
      mt="sm"
      overflowX="auto"
      sx={{
        WebkitOverflowScrolling: 'touch',
        '&::-webkit-scrollbar': {
          display: 'none',
        },
        WebkitMaskImage: 'linear-gradient(to left, transparent 0%, black 24px)',
      }}
    >
      <Box width="auto" whiteSpace="nowrap" pl="sm">
        {platforms.map((platform, i) => {
          const isLast = i === platforms.length - 1;
          return (
            PLATFORMS[platform.id] && (
              <Box display="inline-block" mr={isLast ? 'sm' : '4xs'} key={i}>
                <Button
                  as="a"
                  href={platform.url}
                  colorScheme="white"
                  borderRadius="full"
                  borderColor="whiteAlpha.400"
                  variant="outline"
                  size="xs"
                  leftIcon={PLATFORMS[platform.id].icon}
                >
                  {PLATFORMS[platform.id].title}
                </Button>
              </Box>
            )
          );
        })}
      </Box>
    </Box>
  );
}
